import React from "react";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";

const popover = (
  <Popover id="popover-basic">
    <Popover.Header as="h3" className="text-center">
      Contact support
    </Popover.Header>
    <Popover.Body className="text-primary">
      <p className="mb-1">
        Email:{" "}
        <a href="mailto:support@proctorme.com" className="fw-bold">
          support@proctorme.com
        </a>
      </p>
      <p className="mb-0">
        Phone: <strong>08135598433</strong>
      </p>
    </Popover.Body>
  </Popover>
);

const HelpPopover = () => {
  return (
    <div>
      <OverlayTrigger trigger="click" placement="bottom" overlay={popover}>
        <p className="fw-bold link-text cursor-pointer text-darkblue mb-0 h6">
          help ?
        </p>
      </OverlayTrigger>
    </div>
  );
};

export default HelpPopover;
